import * as classnames from 'classnames/bind'
import * as React from 'react'
import styles from './text-input.scss'

const cx = classnames.bind(styles)

interface IProps extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  fluid?: boolean
  error?: string
}

class TextInput extends React.Component<IProps> {
  public render() {
    const { fluid, error, ...parentProps } = this.props
    const className = cx(
      {
        base: true,
        fluid,
        error,
      },
      this.props.className,
    )
    return (
      <input
        {...parentProps}
        className={className}
      />
    )
  }
}

export default TextInput



// WEBPACK FOOTER //
// ./src/components/TextInput/index.tsx